import { Pipe, PipeTransform } from '@angular/core';
import { LOCALSTORAGE_KEYS } from 'src/config';

@Pipe({
    name: 'dateTz'
})
export class DateTzPipe implements PipeTransform {
    transform(value: any, showTime: boolean = true, showDate: boolean = true): any {
        if (!value) {
            return '';
        }

        const timezone = localStorage.getItem(LOCALSTORAGE_KEYS.TIMEZONE) ?? 'Europe/Paris';
        const locale = localStorage.getItem(LOCALSTORAGE_KEYS.LOCALE) ?? 'fr';

        const options: Intl.DateTimeFormatOptions = {
            timeZone: timezone
        };

        if (showDate) {
            options.year = 'numeric';
            options.month = '2-digit';
            options.day = '2-digit';
        }

        if (showTime) {
            options.hour = '2-digit';
            options.minute = '2-digit';
            options.second = '2-digit';
        }

        const dateFormatter = new Intl.DateTimeFormat(locale, options);
        return dateFormatter.format(new Date(value));
    }
}